import { useEffect, useRef, useState } from 'react'
import { DEFAULT_LENGTH, DEFAULT_MARGIN } from '../constants'
import { animateValues, createLoadingAnimation, getLoudnessFromURL } from '../functions'
import { SoundwaveOptions } from '../types'

export const useSoundwave = ({ margin = DEFAULT_MARGIN, url, lineId }: SoundwaveOptions) => {
  const svgRef = useRef<SVGSVGElement>(null)
  const [length, setLength] = useState<number>(DEFAULT_LENGTH)

  useEffect(() => {
    const svg = svgRef.current
    if (!svg) return
    const { width, height } = svg.getBoundingClientRect()
    svg.setAttribute('viewBox', `1 0 ${width} ${height}`)
    setLength(Math.floor(width / margin))
  }, [margin])

  const animeRef = useRef<anime.AnimeInstance>()

  useEffect(() => {
    if (length === 0) return
    if (!animeRef.current) {
      animeRef.current = createLoadingAnimation(`#${lineId}`)
    }
  }, [length])

  const loudnessRef = useRef<Promise<any>>()

  useEffect(() => {
    if (!url) return animeRef.current?.restart()
    if (loudnessRef.current) return
    loudnessRef.current = (async () => {
      const loudness = await getLoudnessFromURL(url)
      animeRef.current?.pause()
      return animateValues(`#${lineId}`, loudness)
    })()
      .catch((err) => console.log(err))
      .finally(() => (loudnessRef.current = undefined))
  }, [url])
  return { length, svgRef }
}
